import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingTop: 10,
    },
    textContent: {
      paddingTop: 5,
      fontSize: 14,
    }
  })
);

export default useStyles;
